import React from "react";
import { observer } from "mobx-react";
import CheckBox from "Components/common/CheckBox";
import { dataSearchState } from "../state";

/**
 * Simple checkbox list for filter panel (Employee Size, Annual Revenue, etc.).
 * Uses only filter-panel__* classes — no .dropdownList so no global dropdown styles apply.
 */
const FilterPanelCheckboxList = observer(({ id, options = [] }) => {
  const selected = dataSearchState.filterComponentData?.[id] || [];

  const handleChange = (optionId, checked) => {
    let next = [...selected];
    if (checked) {
      if (!next.includes(optionId)) next.push(optionId);
    } else {
      next = next.filter((x) => x !== optionId);
    }
    dataSearchState.setFilterComponentData({
      ...dataSearchState.filterComponentData,
      [id]: next
    });
  };

  const visibleOptions = (options || []).filter((opt) => opt?.show !== false);

  return (
    <div className="filter-panel__list" role="listbox" aria-multiselectable="true">
      {visibleOptions.map((opt) => {
        const optionId = opt.id ?? opt.value;
        const label = opt.value ?? opt.id ?? "";
        const checked = selected.includes(optionId);
        return (
          <label key={optionId} className="filter-panel__option">
            <CheckBox
              name=""
              id={optionId}
              checked={checked}
              cbk={(newChecked) => handleChange(optionId, newChecked)}
            />
            <span className="filter-panel__option-label">{label}</span>
          </label>
        );
      })}
    </div>
  );
});

export default FilterPanelCheckboxList;
